/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getContrastColor, getCssDemention } from "src/libs/utilities"
import { CardsContent, ICard, ILandingSection, ITimelineDot } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface IHorizontalTimelineDotProps {
   dot: ICard
   i: number
   data: CardsContent
   section: ILandingSection
   containerWidth: number
   onClick: () => void
   isActive: boolean
}
const HorizontalTimelineDot = (props: IHorizontalTimelineDotProps): JSX.Element => {
    const { i, data, section, dot, containerWidth, } = props
    const dots: ITimelineDot = props.data.dots
    
    useEffect(() => {

        setTimeout(() => {
            const cardElement: HTMLDivElement | null = document.querySelector(`.landing-card-${dot.id}`)
            if(!cardElement) return 
            const left =  containerWidth / ( data.cards?.length || 1 ) * i
            addCSSClass(
                `h-dot-${ dot.id }-${ i }`,
                `.h-dot-${ dot.id }-${ i } {  
                    left: ${ left + 30 }px;  
                }`
            )
        }, 100)

        return () => { 
            removeCSSClass(`h-dot-${ dot.id }-${ i }`)
        }
    }, [ containerWidth ])

    return <div 
        className={`h-timeline-dot h-dot-${ dot.id }-${ i } ${ props.isActive ? "active" : "" }`} 
        onClick={props.onClick} 
        style={{ left: containerWidth / ( data.cards?.length || 1 ) * (i + .5) }}
        data-timeline-id={  dot.id }
    >
       { i + 1 } 
    </div>
}
export default HorizontalTimelineDot